// export const MAIN_API = "http://127.0.0.1:8002/api/v1";
export const MAIN_API = "https://api.vssgroup.az/api/v1";
// export const MAIN_API = "http://10.0.0.131:8002/api/v1";